// Get Assignment Creators Performance
export const GET_ASSIGNMENT_CREATORS_PERFORMANCE_REQUEST = 'GET_ASSIGNMENT_CREATORS_PERFORMANCE_REQUEST';
export const GET_ASSIGNMENT_CREATORS_PERFORMANCE_DONE = 'GET_ASSIGNMENT_CREATORS_PERFORMANCE_DONE';
export const GET_ASSIGNMENT_CREATORS_PERFORMANCE_FAILED = 'GET_ASSIGNMENT_CREATORS_PERFORMANCE_FAILED';

// Operations
export const TOGGLE_ASSIGNMENT_CREATORS_PERFORMANCE = 'TOGGLE_ASSIGNMENT_CREATORS_PERFORMANCE';
export const TOGGLE_ALL_ASSIGNMENT_CREATORS_PERFORMANCE = 'TOGGLE_ALL_ASSIGNMENT_CREATORS_PERFORMANCE';
export const SET_ASSIGNMENT_CREATORS_PERFORMANCE_FILTER = 'SET_ASSIGNMENT_CREATORS_PERFORMANCE_FILTER';
export const SET_ASSIGNMENT_CREATORS_PERFORMANCE_ALL_FILTERS = 'SET_ASSIGNMENT_CREATORS_PERFORMANCE_ALL_FILTERS';
export const CLEAR_ASSIGNMENT_CREATORS_PERFORMANCE_FILTERS = 'CLEAR_ASSIGNMENT_CREATORS_PERFORMANCE_FILTERS';
export const ASSIGNMENT_CREATORS_PERFORMANCE_SET_PAGE = 'ASSIGNMENT_CREATORS_PERFORMANCE_SET_PAGE';